import reducer from 'state/loads/reducers';
import selectors from 'state/loads/selectors';
import actions from 'state/loads/actionCreators';
import types from 'state/loads/actionTypes';
import effects from 'state/loads/effects';

export { actions, effects, selectors, types };

export default reducer;
